import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "pb-5 text-lg leading-7 font-medium text-black" }, "Select a branching type:", -1)
const _hoisted_2 = { class: "flex flex-col gap-y-3" }

import { Component } from "vue"
import BranchTypeCard from "@/components/workflows/sidebar/action/branch/BranchTypeCard.vue"
import SinglePropertyComponent from "@/components/workflows/sidebar/action/branch/SinglePropertyComponent.vue"
import MergeIcon from "@/components/icons/MergeIcon.vue"
import MultiplePropertiesComponent from "@/components/workflows/sidebar/action/branch/MultiplePropertiesComponent.vue"
import MultipleBranchesComponent from "@/components/workflows/sidebar/action/branch/MultipleBranchesComponent.vue"
import PercentageSplitComponent from "@/components/workflows/sidebar/action/branch/PercentageSplitComponent.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'BranchSidebarComponent',
  emits: ["changeAction"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const branchTypes = [
    {
        title: "Based on a single property",
        condition: "(if ‘property’ is)",
        example: "Send contacts to the branch named John if their first name is John.",
        component: SinglePropertyComponent,
    },
    {
        title: "Based on multiple object properties",
        condition: "(if/then)",
        example: "Send contacts to the branch named West coast list if their location equals Oregon.",
        component: MultiplePropertiesComponent,
    },
    {
        title: "Based on multiple branches filtering",
        condition: "(if/then)",
        example:
            "Send contacts to branch 1 that has a set of filters, if those are true perform action then move on to branch 2 and so on.",
        component: MultipleBranchesComponent,
    },
    {
        title: "Based on percentage split",
        condition: "(if/then)",
        example: "Sends contacts to randomly to percentage split branches.",
        component: PercentageSplitComponent,
    },
]

function selectBranchType(sidebarComponent: Component) {
    emit("changeAction", {
        icon: MergeIcon,
        title: "Configure branch...",
        sidebarComponent,
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(branchTypes, (branchType) => {
        return _createVNode(BranchTypeCard, {
          key: branchType.title,
          title: branchType.title,
          condition: branchType.condition,
          example: branchType.example,
          onClick: ($event: any) => (selectBranchType(branchType.component))
        }, null, 8, ["title", "condition", "example", "onClick"])
      }), 64))
    ])
  ], 64))
}
}

})